











































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Session, SessionActionsKeys, SessionActionsPayload } from '@/store/types/session';
import { Action } from 'vuex-class';

@Component({})
export default class extends Vue {
  @Prop(String) sessionPin!: Session['pin'];
  @Prop(Number) id!: Session['id'];
  @Prop(String) name!: Session['name'];
  @Prop(Boolean) selectedOnly!: boolean;

  @Action(SessionActionsKeys.DELETE_SESSION) deleteSession!: (payload: SessionActionsPayload['DELETE_SESSION']) => void;

  snackbar = false;
  snackbarText = '';
  snackbarType = 'success';
  deleteSessionModal = false;
  openMenu = false;

  async createURL(pin: string) {
    const toB64 = btoa(pin);
    const location = window.location.origin;
    const href = `${location}?pin=${toB64}`;
    await this.copy(href, 'URL');
  }

  async copy(text: string, type: string) {
    return navigator.clipboard
      .writeText(text)
      .then(() => {
        this.snackbarText = `${type} is copied to clipboard`;
        this.snackbarType = 'success';
        this.snackbar = true;
      })
      .catch(() => {
        const textArea = document.createElement('textarea');
        textArea.classList.add('textarea');

        textArea.value = text;
        textArea.textContent = text;

        document.body.appendChild(textArea);

        const selection = document.getSelection();
        const range = document.createRange();
        range.selectNode(textArea);
        if (selection) {
          selection.removeAllRanges();
          selection.addRange(range);
          try {
            document.execCommand('copy');
            selection.removeAllRanges();
            this.snackbarText = `${type} is copied to clipboard`;
            this.snackbarType = 'success';
            this.snackbar = true;
          } catch (err) {
            this.snackbarText = `Oops, unable to copy ${type} `;
            this.snackbarType = 'error';
            this.snackbar = true;
          }
        }

        document.body.removeChild(textArea);
      });
  }
}
